module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/addeditspeciality/addeditspeciality.component.css
// module id = ./src/app/component/addeditspeciality/addeditspeciality.component.css
// module chunks = main